import React from "react";
import AdBanners from "@/components/AdBanners";

interface PageWrapProps {
    children: React.ReactNode
}
export default function MainWrap({children}: PageWrapProps) {
    return (
        <div className="main-wrap">
            <AdBanners/>
            <main>
                {children}
            </main>
        </div>
    )
}